// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif; */
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
}

code {
  /* font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace; */
}

/* Track */
::-webkit-scrollbar-track {
  background-color: gray;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background-color: white;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {}


.backGround {
  align-items: center;
  display: flex;
  position: absolute;
  flex-direction: column;
  width: 100%;
  padding: 0;
  height: 150vh;
  /*height of page*/
}

.contentContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4vh;
  /* Per posizionare il contenitore più in basso nella pagina */
  position: relative;
  /* Aggiunta per il posizionamento relativo del div interno */
}

.title {
  background: -webkit-linear-gradient(right, #53dabd, #9352dd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-position: right;
  background-size: 200%;
  font-size: 3em;
  margin-bottom: .3rem;
  font-weight: bold;
  transition: background-position ease 0.3s;
}

.title:hover {
  background-position: left;
}

.titleUnder {
  color: #000;
  font-size: 1.1em;
  /* Spazio tra titleUnder e sotto titolo */
}

.underTitle {
  font-size: 1.1em;
  color: rgba(94, 91, 91, 0.719);
  text-align: center;
  margin-top: 3%;
  /* Spazio tra titleUnder e sotto titolo */
  margin-bottom: -4vh;
}

.input-group {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 70%;
  position: relative;
  top: 2%;
}

/* .inputContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
  position: relative;
  top: 2%;
} */

.inputText {
  width: 100%;
  height: 8vh;
  border-radius: 5px;
  border: 1px solid rgba(94, 91, 91, 0.719);
  padding: 1%;
  transition: 0.5s;
  color: rgba(94, 91, 91, 0.719);
}

.enterButton {
  width: 6%;
  height: 8vh;
  border-radius: 5px;
  border: none;
  background-color: rgba(94, 91, 91, 0.719);
  margin-left: 0.5%;
  transition: 0.5s;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4vh;
  /* Ridotto leggermente per fare spazio all'icona */
}

.enterButton span {
  display: flex;
  align-items: center;
  justify-content: center;
}


.containerGraph {
  display: flex;
  position: relative;
  margin-top: 1rem;
  padding: .8rem;
  border: 1px solid #5e5b5bb7;
  align-items: center;
  justify-content: center;
  width: 75%;
  border-radius: 5px;
  background-color: white;
  height: 90%;
  /* overflow: hidden; */
  overflow: visible;
}

.buttonContainer {
  top: 0;
  margin: 0;
  position: relative;
  width: 100%;
}

.hideButton {
  background-color: black;
  ;
  border-radius: 5vh;
  padding: 4vh;
  width: 15%;
  margin-top: 1%;
  left: 35%;
  position: absolute;
  color: white;
  cursor: pointer;
}

.graphButton {
  background-color: black;
  ;
  border-radius: 5vh;
  padding: 4vh;
  width: 15%;
  margin-top: 1%;
  left: 50%;
  position: absolute;
  color: white;
  cursor: pointer;
}

.menuOptionsButton {
  position: fixed;
  width: 4rem;
  height: 4rem;
  top: 3%;
  right: 2%;
  cursor: pointer;
  background-color: transparent;
  color: #000000cc;
  border-radius: 5px;
  border: 1px solid #000000cc;
  font-size: 1.3rem;
  text-transform: uppercase;
  transition: background-color 0.2s ease;
}



.menuOptionsButton:hover {
  background-color: transparent;
  border: 1px solid #fff;
}


.ContainerPersonalized {
  position: absolute;
  transition: width 0.3s ease-in-out;
  width: 100%;
}

.menu-options-open {
  width: 90%;
  left: 0;
}

.menu-graph-open {
  width: 90%;
  right: 0;
}

.menu-graph-open.menu-options-open {
  width: 80%;
  left: 10%;
  right: 10%
}

.graph-footer {
  display: flex;
  /* justify-content: space-between; */
  justify-content: center;
  /* width: 95%; */
  width: -moz-fit-content;
  width: fit-content;
}

.exit-container {
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  width: 70%;
}

.btn-danger {
  width: 10%;
}

.required {
  color: red;
}

.row-delete-btn {
  background: none;
  border: none;
  color: orange;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0;
  transition: color 0.2s ease;
}

.row-delete-btn:hover {
  color: red;
}


.pagination {
  margin: 1rem;
}

.summary-container {
  width: 70%;
  min-height: 8rem;
  max-height: 14rem;
  overflow-y: auto;
  margin: 1rem .5rem;
  padding: 1.2rem;
  background-color: #fff;
  border: 1px solid gray;
  border-radius: .5rem;
}

.highlight {
  color: white;
  cursor: help;
}

/* DisplayGraph page: white instead of the app-wide grey (App.css) */
body.display-graph-page {
  background-color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/style/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;iBAEe;EACf;uCACqC;AACvC;;AAEA;EACE;gBACc;AAChB;;AAEA,UAAU;AACV;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB,iCAAiC;;;AAGjC;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,6DAA6D;EAC7D,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;EAC5D,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,OAAO;AACT;;AAEA;;;;;;;GAOG;;AAEH;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;;EAEvB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;;EAEvB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,OAAO;EACP,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;AACxC;;;;AAIA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,OAAO;AACT;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAkB;EAAlB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,oEAAoE;AACpE;EACE,yBAAyB;AAC3B","sourcesContent":["body {\n  margin: 0;\n  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif; */\n  /* -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; */\n}\n\ncode {\n  /* font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace; */\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background-color: gray;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background-color: white;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {}\n\n\n.backGround {\n  align-items: center;\n  display: flex;\n  position: absolute;\n  flex-direction: column;\n  width: 100%;\n  padding: 0;\n  height: 150vh;\n  /*height of page*/\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 4vh;\n  /* Per posizionare il contenitore più in basso nella pagina */\n  position: relative;\n  /* Aggiunta per il posizionamento relativo del div interno */\n}\n\n.title {\n  background: -webkit-linear-gradient(right, #53dabd, #9352dd);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-position: right;\n  background-size: 200%;\n  font-size: 3em;\n  margin-bottom: .3rem;\n  font-weight: bold;\n  transition: background-position ease 0.3s;\n}\n\n.title:hover {\n  background-position: left;\n}\n\n.titleUnder {\n  color: #000;\n  font-size: 1.1em;\n  /* Spazio tra titleUnder e sotto titolo */\n}\n\n.underTitle {\n  font-size: 1.1em;\n  color: rgba(94, 91, 91, 0.719);\n  text-align: center;\n  margin-top: 3%;\n  /* Spazio tra titleUnder e sotto titolo */\n  margin-bottom: -4vh;\n}\n\n.input-group {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 70%;\n  position: relative;\n  top: 2%;\n}\n\n/* .inputContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 70%;\n  position: relative;\n  top: 2%;\n} */\n\n.inputText {\n  width: 100%;\n  height: 8vh;\n  border-radius: 5px;\n  border: 1px solid rgba(94, 91, 91, 0.719);\n  padding: 1%;\n  transition: 0.5s;\n  color: rgba(94, 91, 91, 0.719);\n}\n\n.enterButton {\n  width: 6%;\n  height: 8vh;\n  border-radius: 5px;\n  border: none;\n  background-color: rgba(94, 91, 91, 0.719);\n  margin-left: 0.5%;\n  transition: 0.5s;\n  cursor: pointer;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 4vh;\n  /* Ridotto leggermente per fare spazio all'icona */\n}\n\n.enterButton span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.containerGraph {\n  display: flex;\n  position: relative;\n  margin-top: 1rem;\n  padding: .8rem;\n  border: 1px solid #5e5b5bb7;\n  align-items: center;\n  justify-content: center;\n  width: 75%;\n  border-radius: 5px;\n  background-color: white;\n  height: 90%;\n  /* overflow: hidden; */\n  overflow: visible;\n}\n\n.buttonContainer {\n  top: 0;\n  margin: 0;\n  position: relative;\n  width: 100%;\n}\n\n.hideButton {\n  background-color: black;\n  ;\n  border-radius: 5vh;\n  padding: 4vh;\n  width: 15%;\n  margin-top: 1%;\n  left: 35%;\n  position: absolute;\n  color: white;\n  cursor: pointer;\n}\n\n.graphButton {\n  background-color: black;\n  ;\n  border-radius: 5vh;\n  padding: 4vh;\n  width: 15%;\n  margin-top: 1%;\n  left: 50%;\n  position: absolute;\n  color: white;\n  cursor: pointer;\n}\n\n.menuOptionsButton {\n  position: fixed;\n  width: 4rem;\n  height: 4rem;\n  top: 3%;\n  right: 2%;\n  cursor: pointer;\n  background-color: transparent;\n  color: #000000cc;\n  border-radius: 5px;\n  border: 1px solid #000000cc;\n  font-size: 1.3rem;\n  text-transform: uppercase;\n  transition: background-color 0.2s ease;\n}\n\n\n\n.menuOptionsButton:hover {\n  background-color: transparent;\n  border: 1px solid #fff;\n}\n\n\n.ContainerPersonalized {\n  position: absolute;\n  transition: width 0.3s ease-in-out;\n  width: 100%;\n}\n\n.menu-options-open {\n  width: 90%;\n  left: 0;\n}\n\n.menu-graph-open {\n  width: 90%;\n  right: 0;\n}\n\n.menu-graph-open.menu-options-open {\n  width: 80%;\n  left: 10%;\n  right: 10%\n}\n\n.graph-footer {\n  display: flex;\n  /* justify-content: space-between; */\n  justify-content: center;\n  /* width: 95%; */\n  width: fit-content;\n}\n\n.exit-container {\n  display: flex;\n  justify-content: center;\n  margin: 1rem 0;\n  width: 70%;\n}\n\n.btn-danger {\n  width: 10%;\n}\n\n.required {\n  color: red;\n}\n\n.row-delete-btn {\n  background: none;\n  border: none;\n  color: orange;\n  width: fit-content;\n  margin: 0;\n  transition: color 0.2s ease;\n}\n\n.row-delete-btn:hover {\n  color: red;\n}\n\n\n.pagination {\n  margin: 1rem;\n}\n\n.summary-container {\n  width: 70%;\n  min-height: 8rem;\n  max-height: 14rem;\n  overflow-y: auto;\n  margin: 1rem .5rem;\n  padding: 1.2rem;\n  background-color: #fff;\n  border: 1px solid gray;\n  border-radius: .5rem;\n}\n\n.highlight {\n  color: white;\n  cursor: help;\n}\n\n/* DisplayGraph page: white instead of the app-wide grey (App.css) */\nbody.display-graph-page {\n  background-color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
